import React from "react";
import * as XLSX from "xlsx";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  InputAdornment,
  TextField,
  Divider,
} from "@mui/material";

import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { Link } from "react-router-dom";

import { IconFileDownload, IconPlus, IconSearch } from "@tabler/icons";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { writeFile } from "xlsx";
import LocationService from "src/service/location";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Location",
  },
];

const POILocation = () => {
  const navigate = useNavigate();
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [locationdata, setLocation] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [visibleData, setVisibleData] = useState([]);

  //  for table sorting
  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'
  const [sortColumn, setSortColumn] = useState("location_name"); // Initial column to sort

  const fetch_locationdata = async () => {
    try {
      const res = await LocationService.get_location_list({});
      console.log("res.data===", res.data);
      setLocation(res.data);
      setVisibleData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch_locationdata();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterLoaction = locationdata.filter(
    (man) =>
      (man.location_name &&
        man.location_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (man.radius &&
        man.radius.toString().includes(searchTerm.toLowerCase())) ||
      (man.lat && man.lat.toString().includes(searchTerm.toLowerCase())) ||
      (man.lng && man.lng.toString().includes(searchTerm.toLowerCase()))
  );

  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const filteredData = locationdata.filter((man) =>
      man.location_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const visibleData = filteredData.slice(startIndex, endIndex);
    setVisibleData(visibleData);
  }, [locationdata, page, rowsPerPage, searchTerm]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const deleteLocation = async (id) => {
    swal({
      title: "Delete Location",
      text: "Are you sure you want to delete Location ?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await LocationService.delete_location({
            id: id,
            d_by: sessionData.data.id,
          });
          if (response.status === 200) {
            swal("success", response.message, "success");

            fetch_locationdata();
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };

  const handleExport = () => {
    const headers = ["Sl. No", "Location Name", "Lat", "Lng", "Radius (In Km)"];

    const data = visibleData.map((man, index) => [
      index + 1,
      man?.location_name,
      man?.lat,
      man?.lng,
      man?.radius,
    ]);

    const exportData = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const fileName = "Location Report.xlsx";

    writeFile(wb, fileName);
  };

  // table column sorting start here
  // eslint-disable-next-line no-unused-vars
  const handleSort = (column) => {
    // Toggle sorting order if clicking on the same column
    if (sortColumn === column) {
      setSortOrder((prevSortOrder) =>
        prevSortOrder === "asc" ? "desc" : "asc"
      );
    } else {
      // Set new column to sort
      setSortColumn(column);
      // Default sorting order for the new column
      setSortOrder("asc");
    }
  };

  const sortedEsclation = filterLoaction.sort((a, b) => {
    const compareValueA = a[sortColumn];
    const compareValueB = b[sortColumn];

    // Customize the comparison based on data types or specific conditions
    if (sortOrder === "asc") {
      return compareValueA.localeCompare(compareValueB);
    } else {
      return compareValueB.localeCompare(compareValueA);
    }
  });

  // ====================================
  return (
    <PageContainer title="Location" description="this is Basic Table page">
      {/* breadcrumb */}
      <Breadcrumb title="Location" items={BCrumb} />
      {/* end breadcrumb */}

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Location
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/addpoilocation");
              }}
            >
              <IconPlus width={20} />
            </Button>

            <Button variant="contained" color="success" onClick={handleExport}>
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size="1.1rem" />
                  </InputAdornment>
                ),
              }}
              placeholder=" Search "
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
        </Grid>
        {/* </ParentCard> */}
        <Paper variant="outlined">
          <TableContainer>
            <Table
              aria-label="simple table"
              sx={
                {
                  // whiteSpace: "nowrap",
                }
              }
            >
              <TableHead style={{ backgroundColor: "#895c5c33" }}>
                <TableRow>
                  <TableCell>
                    <Typography style={{ fontSize: "14px" }} variant="h6">
                      Sl. No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Location Name
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Latitude
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Longitude
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Radius (In Km)
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Action
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedEsclation.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={11} style={{ textAlign: "center" }}>
                      <Typography
                        style={{ fontSize: "13px" }}
                        variant="h6"
                        sx={{ color: "red" }}
                      >
                        No records found!!
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  sortedEsclation
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((man, index) => (
                      <TableRow key={man.id}>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {index + 1}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man?.location_name ?? "NA"}
                          </Typography>
                        </TableCell>

                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man?.lat ?? "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man?.lng ?? "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man?.radius ?? "NA"}
                          </Typography>
                        </TableCell>

                        <TableCell
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Link to={`/updatepoilocation/${man.id}`}>
                            <ModeEditOutlinedIcon
                              style={{
                                color: "blue",
                                fontSize: "18px",
                                cursor: "pointer",
                              }}
                            />
                          </Link>
                          <DeleteOutlinedIcon
                            style={{
                              color: "red",
                              fontSize: "18px",
                              marginLeft: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => deleteLocation(man.id)}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100, 500]}
          component="div"
          count={sortedEsclation.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </ParentCard>
    </PageContainer>
  );
};

export default POILocation;
